import React, { useEffect, useState } from 'react';
import Link from 'next/link';
import classes from './LoginBar.module.scss';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { LOGGED_OUT_KEY } from '@/components/shared/constants';

const LoginBar: React.FC = () => {
  const [signinFlag, setSigninFlag] = useState(false);

  useEffect(() => {
    fetch('/api/config')
      .then((res) => res.json())
      .then((data) => {
        console.log("Runtime ENABLE_SIGNIN::", data.enableSignin);
        setSigninFlag(data.enableSignin);
      })
      .catch(() => setSigninFlag(false));
  }, []);

  const handleSignInClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    localStorage.removeItem(LOGGED_OUT_KEY);
    window.location.href = '/secure/dashboard'; // Redirect to dashboard
  };
  return (
    <div className={classes.loginBar}>
      { signinFlag ? (
     <Link
        href={'/secure/dashboard'}
        className={`${classes.button} !font-bold text-xs mt-1`}
        onClick={handleSignInClick}
      >
        <span className="inline-block">Sign In</span> {" "}
        <FontAwesomeIcon icon="chevron-right" />
      </Link>) : ""
      }
    </div>
  );
};

export default LoginBar;
